import { GenAILogo } from '@/components/icons/GenAILogo';
import useStyles from './styles';

export const AppLoader = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <GenAILogo className={classes.logo} />
      <div className={classes.content}>
        <span className={classes.title}>GenAI Studio</span>
        <div className={classes.dots}>
          <span className={classes.dot} />
          <span className={classes.dot} />
          <span className={classes.dot} />
        </div>
      </div>
    </div>
  );
};

export default AppLoader;
